<template>
  <div class="flex flex-col lg:h-0 lg:min-h-full">
    <div class="flex-none px-2">
      <h5 class="text-sm font-medium text-gray-600 mb-2">Details</h5>
    </div>
    <div class="flex-1 lg:h-0">
      <div class="h-full overflow-auto fancy-scrollbar px-2">
        <div>
          <div class="list list-spaced rounded">
            <div class="px-4">
              <div class="flex flex-col">
                <span class="font-medium text-sm text-gray-600">Email</span>
                <a v-if="contactRequest.email" :href="`mailto:${contactRequest.email}`">
                  {{ contactRequest.email }}
                </a>
                <span v-else>{{ contactRequest.email }}</span>
              </div>
            </div>

            <div class="px-4">
              <div class="flex flex-col">
                <span class="font-medium text-sm text-gray-600">Phone</span>
                <a v-if="hasValidPhoneFormat" :href="`tel:+30${contactRequest.phone}`"
                  >{{ contactRequest.phone }}
                </a>
                <span v-else>{{ contactRequest.phone }}</span>
              </div>
            </div>

            <template v-if="contactRequest.customFields">
              <div
                v-for="(customField, key) in contactRequest.customFields"
                :key="key"
                class="px-4"
              >
                <div class="flex flex-col flex-1">
                  <span class="font-medium text-sm text-gray-600 capitalize">{{
                    customField.name
                  }}</span>
                  <p
                    v-if="customField.value"
                    :class="[startsWithHttp(customField.value) ? 'break-all' : 'break-words']"
                  >
                    {{ customField.value }}
                  </p>
                  <p v-else>N/A</p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasValidPhoneFormat() {
      if (!this.contactRequest || !this.contactRequest.phone) return false;
      return /^\d{10}$/.test(this.contactRequest.phone);
    },
  },

  methods: {
    startsWithHttp(value) {
      if (typeof value !== 'string') {
        return false;
      }

      return value.startsWith('http');
    },
  },
};
</script>
